@if (value) {
  <span #valueField>
    {{value}}
  </span>
}

